import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible'
import axios from './config/http'
import 'animate.css'

Vue.config.productionTip = false
Vue.prototype.$axios = axios

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
